import { createLocale } from '@shared/i18n'

import en from './locales/en'
import es from './locales/es'
import fr from './locales/fr'

export default createLocale(en, fr, es)
